var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useState } from "react";
import RecentlySearchedBlock from "./Generic/RecentlySearchedBlock";
import { cInfrastructures } from "@mainDi/webDi";
import filter from "@domains/utils/filter";
// import { getStockElement } from "./AllSearchDataBlock";
import { useLocation, useNavigate } from "react-router-dom";
import { GetStockElement } from "./AllSearchDataBlock";
import searchDi from "@mainDi/features/Search/servicelocator";
export var AddRecentSearchList = function (name, symbol, assetType, length) { return __awaiter(void 0, void 0, void 0, function () {
    var searchList, searchListJson, lengthNum, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, cInfrastructures.localStorage.get(name)];
            case 1:
                searchList = _a.sent();
                searchListJson = [];
                lengthNum = length;
                if (!!searchList && symbol) {
                    searchListJson = JSON.parse(searchList);
                    if (searchListJson.find(function (x) { return x.symbol === symbol; })) {
                        // return;
                        searchListJson.splice(searchListJson.findIndex(function (x) { return x.symbol === symbol; }), 1);
                        // searchListJson.unshift(symbol);
                    }
                    else if (length && searchListJson.length >= lengthNum) {
                        searchListJson.splice(searchListJson.length - 1, 1);
                    }
                    searchListJson.unshift({ symbol: symbol, assetType: assetType });
                }
                else
                    searchListJson.unshift({ symbol: symbol, assetType: assetType });
                cInfrastructures.localStorage.set(name, JSON.stringify(searchListJson));
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getRecentSearchList = function (name) { return __awaiter(void 0, void 0, void 0, function () {
    var searchList, searchListJson, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, cInfrastructures.localStorage.get(name)];
            case 1:
                searchList = _a.sent();
                searchListJson = [];
                if (searchList.length > 0) {
                    searchListJson = JSON.parse(searchList);
                    // const resList = await tocDi.tocJourney.getMultiQuote({
                    //   symLst: searchListJson,
                    // });
                    return [2 /*return*/, searchListJson];
                }
                return [3 /*break*/, 3];
            case 2:
                error_2 = _a.sent();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var RecentSearch = function (props) {
    var navigate = useNavigate();
    var state = useLocation().state;
    var localStorage = useMemo(function () { return cInfrastructures.localStorage; }, []);
    var _a = __read(useState(props.list), 2), list = _a[0], setList = _a[1];
    var _b = __read(useState(false), 2), edit = _b[0], setEdit = _b[1];
    var _c = __read(useState(false), 2), loader = _c[0], setLoader = _c[1];
    var filterList = useMemo(function () {
        if (!!(props === null || props === void 0 ? void 0 : props.type) && list) {
            return filter(list, [{ key: "assetType", value: props === null || props === void 0 ? void 0 : props.type }]);
        }
        else
            return list;
    }, [list]);
    // useEffect(() => {
    //   setList(props.list);
    // }, [props.list]);
    var deleteSearchList = function (name, symbol, assetType) { return __awaiter(void 0, void 0, void 0, function () {
        var searchList, searchListJson, index, indexData, newList, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setLoader(true);
                    return [4 /*yield*/, localStorage.get(name)];
                case 1:
                    searchList = _a.sent();
                    searchListJson = [];
                    if (!!(props === null || props === void 0 ? void 0 : props.accountCode)) {
                        searchDi.search.deleteRecentList({
                            accountId: props === null || props === void 0 ? void 0 : props.accountCode,
                            assetType: assetType,
                            symbol: symbol,
                        });
                    }
                    if (!!searchList) {
                        searchListJson = JSON.parse(searchList);
                        index = searchListJson.findIndex(function (x) { return x.symbol === symbol; });
                        indexData = list.findIndex(function (x) { return x.symbol === symbol; });
                        if (indexData >= 0) {
                            newList = __spreadArray([], __read(list), false);
                            newList.splice(indexData, 1);
                            setList(newList);
                            props === null || props === void 0 ? void 0 : props.setList(newList);
                        }
                        if (index >= 0) {
                            searchListJson.splice(index, 1);
                            localStorage.set(name, JSON.stringify(searchListJson));
                        }
                    }
                    setLoader(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var clearSearchList = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!!(props === null || props === void 0 ? void 0 : props.accountCode)) return [3 /*break*/, 1];
                    setLoader(true);
                    searchDi.search
                        .deleteRecentList({
                        accountId: props === null || props === void 0 ? void 0 : props.accountCode,
                    })
                        .finally(function () {
                        setLoader(false);
                        setList([]);
                    });
                    return [3 /*break*/, 4];
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setLoader(true);
                    return [4 /*yield*/, localStorage.set(name, JSON.stringify([]))];
                case 2:
                    _a.sent();
                    setList([]);
                    if (props === null || props === void 0 ? void 0 : props.setList) {
                        props.setList([]);
                    }
                    setLoader(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    console.error("Error clearing search list:", error_4);
                    // setError("Failed to clear search list. Please try again.");
                    setLoader(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", null, (filterList === null || filterList === void 0 ? void 0 : filterList.length) > 0 && (React.createElement(RecentlySearchedBlock, { stockCount: filterList.length, content: React.createElement(React.Fragment, null, !loader &&
            filterList.map(function (x, idx) {
                var _a;
                return (React.createElement(GetStockElement, { placeOrder: (_a = state === null || state === void 0 ? void 0 : state.placeOrder) !== null && _a !== void 0 ? _a : props === null || props === void 0 ? void 0 : props.placeOrder, accountCode: props === null || props === void 0 ? void 0 : props.accountCode, data: x, navigate: navigate, closePopup: props.closePopup, setShowToc: props.setShowToc, edit: edit, deleteSearch: function (data) {
                        return deleteSearchList("allRecentSearch", data === null || data === void 0 ? void 0 : data.symbol, data === null || data === void 0 ? void 0 : data.assetType);
                    }, inViewCallBack: props.inViewCallBack, setInviewData: props.setInviewData, inViewData: props.inViewData, datalist: filterList, keys: idx, setSearchedQuote: props.setSearchedQuote }));
            })), setEdit: setEdit, editMode: edit, onClearAll: function () { return clearSearchList("allRecentSearch"); } }))));
};
